// JQuery
import 'jquery/dist/jquery.min.js';

// Bootstrap and dependencies
import '@popperjs/core/dist/umd/popper.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';

// Mmenu: Navigation for touch devices
import 'jquery.mmenu/dist/js/jquery.mmenu.all.min.js';

// Parsley: Form validation
import 'parsleyjs/dist/parsley.js';
import 'parsleyjs/dist/i18n/de.js';

// Date Input Polyfill for browser that don't support <input type="date">
import 'nodep-date-input-polyfill';

// Slick slider
// import 'slick-carousel/slick/slick.js';

// cookie consent banner
import './cookieconsentInit.js';

// wow.js
import 'wow.js/dist/wow.js';

// Offcanvas Menu
// https://mmenujs.com/documentation/addons/navbars.html
(function ($) {

  if($('body.neos-backend').length){
    // We're in backend, so we don't render mmenu
    $("#mobile-menu").hide();
    $('.menu-btn').click(function () {
      alert('Mobile-Menü ist im Neos-Backend nicht aktiv.')
    });
  }
  else {

    if($("#mobile-menu").length){
      $("#mobile-menu").mmenu({
        extensions: ["pagedim"],
        offCanvas: {
          position: "front",
          width: "290"
        },
        navbar: {
          title: "",
        },
        navbars: [
          {
            content: ["prev"],
          },
          {
            content: ["title"],
          },
        ]
      }, {
        classNames: {
          selected: "current-menu-item"
        },
      });

      var API = $("#mobile-menu").data("mmenu");
      $(".close-menu").click(function () {
        API.close();
      });
    }

    // Toggle Button Active
    $('.menu-btn').click(function () {
      $(this).toggleClass('active');
      $('.search-btn').removeClass('active');
      $('.search-box').removeClass('show');
      $('.container-main').toggleClass('show-before');
      $('.container-main').removeClass('show-after');
      $('body').removeClass('overflowhidden');
    });
    $('.search-btn').click(function () {
      $(this).toggleClass('active');
      $('.menu-btn').removeClass('active');
      $('.container-main').removeClass('show-before');
      $('.container-main').toggleClass('show-after');
      $('body').toggleClass('overflowhidden');
    });
  }

})(jQuery);


// Search Action
$(document).ready(function () {

  $('.search-box .btn-search').addClass('disabled');
  $('.search-box input[type="text"]').keyup(function () {
    if ($(this).val() != '') {
      $('.search-box .btn-search').removeClass('disabled');
    }
  });

  $('input,textarea').focus(function () {
    $(this).data('placeholder', $(this).attr('placeholder'))
    .attr('placeholder', '');
  }).blur(function () {
    $(this).attr('placeholder', $(this).data('placeholder'));
  });

});

(function ($) {
  // Color the empty select
  $.fn.selectColored = function (options) {
    var defaults = {
      def: -1,
      classSel: 'colorize',
      classEmpty: 'empty',
      classDef: 'def'
    };
    // extend default options with those provided
    var opts = $.extend(defaults, options);

    // implementation code
    return this.each(function () {
      var $select = $(this);
      $select
      .addClass(opts.classSel)
      .find('option[value="' + opts.def + '"]')
      .addClass(opts.classDef);

      function color() {
        $select.toggleClass(opts.classEmpty, ($select.val() == opts.def));
      }

      $select.bind('change', function () {
        color();
      });

      // initialize
      color();
    });
  };// end plugin definition
})(jQuery);

$(document).ready(function () {
  $('select').selectColored();
});
